<template>
    <button @click="$emit('click')" :class="[`btn_${color}`,bordered?'bordered':null]" class="btn" :style="style" :disabled="disabled"> 
          <slot/>
          {{name}}
          <span v-if="icon && iconAfter" v-html="icon" :style="`color : ${iconColor}`"></span>
    </button>
</template>
<script >
export default {

    props: { 
        icon:  { type: String, default: null },
        iconAfter:  { type: Boolean, default: false },
        iconColor: { type : String, default :"#fff"},
        color: { type: String, default: '#fff' },
        bordered : {type : Boolean, default : false},
        padding : { type : Object, default : ()=>({x : 2.5, y: .7})},
        margin : { type : Number, default :0},
        backgroundColor : String, 
        size : { type : String, default : '1rem'},
        radius : { type : Number, default : .3 },
        name : { type : String, default : ''},
        width : { type : String, default : 'auto'},
        borderColor : { type : String, default : '#333'},
        borderWidth : { type : String | Number, default : 1},
        disabled : { type : Boolean, default : false}
    },
    computed: {
        style(){
            return {
                padding : `${this.padding.y}rem ${this.padding.x}rem`,
                margin : `${this.margin}rem`,
                backgroundColor : this.backgroundColor,
                fontSize  :this.size,
                'border-radius' : this.radius + 'rem',
                width : this.width,
                color : this.color,
                'border-color' : this.borderColor,
                'border-width' : this.borderWidth ? this.borderWidth+'px' : 1+'px',

            }
        }
    }

}

</script>

<style lang="scss" scoped>
$primary: #ff4f56;
$secondary: #4309b0;
$tertiary: #32007d;
$tertiary-light: #6d49a2;
$tertiary-light: #6d49a2;

    .btn {
        // border-radius: .3rem;
        border: none;
        // padding: .7rem 2.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $primary;
        color: #ffffff;
        font-weight: 500;
        &:hover{
            opacity: .8
        }
    }
    .btn_primary {
        background-color: $primary;
    }
    .btn_secondary {
        background-color: $secondary;
    }
    .btn_tertiary {
        background-color: $tertiary;
    }
    .btn_tertiary-light {
        background-color: $tertiary-light;
    }
    .bordered {
        border : 1px solid rgb(212, 212, 212);
    }
    span {
        padding : 0 .5rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/global/Button.vue